export default "__VITE_ASSET__DlX17Jwh__"